import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {isIPhone} from 'src/app/components/common/constants';
import {expirationDate} from 'src/app/components/common/validations';
import {SessionService} from 'src/app/services/session.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import * as payform from 'payform/dist/payform.js';

@Component({
    selector: 'app-payment-method',
    templateUrl: './payment-method.component.html',
    styleUrls: ['./payment-method.component.scss'],
})
export class PaymentMethodComponent implements OnInit {
    @Input() active: boolean;
    @Output() paypalMethod: EventEmitter<any> = new EventEmitter<any>();
    @Input() methodData: any;
    @Output() methodDataChange: EventEmitter<any> = new EventEmitter<any>();
    methodInfo: any;
    method = 1;
    isIphone: boolean;
    form: FormGroup;
    cardType: string;
    saveCreditCard = false;
    userData: any;
    methodAdded = false;
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;
    tarjetaValidar = false;
    code = {
        one: '',
        two: '',
        three: '',
        four: '',
        five: '',
    };

    constructor(
        private fb: FormBuilder,
        private sessionService: SessionService,
        private deviceService: DeviceDetectorService
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        this.userData = this.sessionService.getPaymentAccount();
        this.initForm();
        this.refreshSteps();
    }

    ngOnInit(): void {
        this.isIphone = isIPhone();
        if (this.sessionService.getDataPay() != null && this.sessionService.getDataPay() !== '') {
            this.methodInfo = this.sessionService.getDataPay();
            this.form.setValue(this.methodInfo);
            this.code.one = this.methodInfo.creditCard.substring(0, 4);
            this.code.two = this.methodInfo.creditCard.substring(4, 8);
            this.code.three = this.methodInfo.creditCard.substring(8, 12);
            this.code.four = this.methodInfo.creditCard.substring(12, 16);
        }

        this.form.controls.creditCard.valueChanges.subscribe(
            data => {
                this.tarjetaValidar = data === '';
            }
        );
    }

    initForm(): void {
        switch (this.method) {
            case 1:
                this.form = this.fb.group({
                    name: [this.methodData?.name || '', Validators.compose([Validators.required,
                        Validators.minLength(2), Validators.maxLength(50)])],
                    creditCard: [this.methodData?.creditCard || '', Validators.compose([Validators.required, Validators.minLength(15)
                        , Validators.maxLength(16)])],
                    expiration: [this.methodData?.expiration || '', Validators.compose([Validators.required, expirationDate])],
                    cvv: ['', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(4)])],
                    save: [false, Validators.compose([Validators.required])],
                });
                break;
            case 2:
                this.sessionService.setPaymentMethod({
                    type: 'paypal'
                });
                this.refreshSteps();
                this.paypalMethod.emit();
                break;
        }
    }

    toggleSave(event): void {
        this.saveCreditCard = event.checked;
        this.form.controls.saveCreditCard.setValue(this.saveCreditCard);
    }

    clickComponent(): any{
        this.tarjetaValidar = this.code.one === '' ||
            this.code.two === '' ||
            this.code.three === '' ||
            this.code.four === '';
    }

    moveOnMax(id: number, nextFieldID, prevFieldID): void {
        switch (id) {
            case 1:
                if (this.code.one.length === 4) {
                    (document.getElementById(nextFieldID) as HTMLElement).focus();
                    const elemento: any = document.getElementById('one');
                    elemento.type = 'password';
                }
                break;
            case 2:
                if (this.code.two.length === 4) {
                    (document.getElementById(nextFieldID) as HTMLElement).focus();
                    const elemento: any = document.getElementById('two');
                    elemento.type = 'password';
                } else if (this.code.two.length === 0) {
                    (document.getElementById(prevFieldID) as HTMLElement).focus();
                    const elemento: any = document.getElementById(prevFieldID);
                    elemento.type = 'text';
                }
                break;
            case 3:
                if (this.code.three.length === 4) {
                    (document.getElementById(nextFieldID) as HTMLElement).focus();
                    const elemento: any = document.getElementById('three');
                    elemento.type = 'password';
                } else if (this.code.three.length === 0) {
                    (document.getElementById(prevFieldID) as HTMLElement).focus();
                    const elemento: any = document.getElementById(prevFieldID);
                    elemento.type = 'text';
                }
                break;
            case 4:
                if (this.code.four.length === 0) {
                    (document.getElementById(prevFieldID) as HTMLElement).focus();
                    const elemento: any = document.getElementById(prevFieldID);
                    elemento.type = 'text';
                }
                break;
        }
        const code = `${this.code.one}${this.code.two}${this.code.three}${this.code.four}${this.code.five}`;
        this.cardType = payform.parseCardType(code);
        this.form.controls.creditCard.setValue(code);
    }

    refreshSteps(): void {
        const steps = this.sessionService.getPaymentSteps();
        this.methodAdded = steps.methodStep.completed;
        if (this.methodAdded) {
            setTimeout(() => {
                this.methodData = this.sessionService.getDataPay();
                this.methodDataChange.emit(this.methodData);
            }, 200);
        }
    }

    refreshEdit(): void {
        const steps = this.sessionService.getPaymentSteps();
        this.methodAdded = steps.methodStep.completed = false;
        if (this.methodAdded) {
            setTimeout(() => {
                this.methodData = this.sessionService.getDataPay();
                this.methodDataChange.emit(this.methodData);
            }, 200);
        }
    }

    saveData(): void {
        this.sessionService.setDataPay(this.form.getRawValue());
        this.addDataLayer();
        this.refreshSteps();
    }

    addDataLayer(): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
        // @ts-ignore
        dataLayer.push({
            event: 'checkout',
            ecommerce: {
                checkout: {
                    actionField: {step: 2, option: 'Información de Pago'},
                }
            }
        });
    }

}
